import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, notification, Spin, Tabs, Typography } from "antd";
import { AxiosError } from "axios";

import { ICongelamentosPorDiaCompleto } from "../../interfaces";

import { formatDateLocal } from "../../utils";
import { convertMoedaBRDoJSComAte3CasasDecimais, poeValorComPontosEmMil } from "../../../../../../services/Conversores";
import { AbaCongelamentosUnicos } from "../AbaCongelamentosUnicos";
import { AbaCongelamentosEmLote } from "../AbaCongelamentosEmLote";
import ExtratoService from "../../../../../../services/http/services/CongelamentoPorCNPJ/ExtratoService";
import { SairDoSistema } from "../../../../../../services/LStorage/SairSistema";
import { EmitirErro } from "../../../../../../services/EmitirErro";

const { Text } = Typography;

interface IProps {
  visible: boolean;
  date: string | null;
  onClose: () => void;
}

export default function CongelamentosModal({
  visible,
  date,
  onClose,
}: IProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<ICongelamentosPorDiaCompleto | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (!visible || !date) {
      return;
    }

    const controller = new AbortController();

    async function loadData(date: string) {
      try {
        setIsLoading(true);
        const dia = await ExtratoService.getDetalhesDia(date, controller.signal);

        setData(dia);
        setIsLoading(false);
      } catch (error) {
        if (error instanceof AxiosError && error.name === "CanceledError") {
          return;
        }

        let msgErro: any = (error as Error);
        setIsLoading(false);

        if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
          SairDoSistema();
          notification.error({
            message: 'Sessão expirada',
            description:
              'Sua sessão expirou, realize o login novamente!',
          });
          navigate('/');
        } else {
          EmitirErro(error, true, 'extrato_congelamentos_dkwdfaiweyi')
        }

        setIsLoading(false);
      }
    }

    loadData(date);

    return () => {
      controller.abort();
    }
  }, [visible, date]);

  if (!visible) {
    return null;
  }

  return (
    <Modal
      title="Congelamentos"
      visible={visible}
      className="modalCongelamentosPorDia"
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Fechar
        </Button>,
      ]}
    >
      {
        isLoading && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '16px 0'
            }}
          >
            <Spin />
          </div>
        )
      }

      {
        !isLoading && data && (
          <>
            <div
              className='layoutModalInfo_lvbweqrafw'
              style={{
                borderRadius: 8,
                padding: 5
              }}
            >
              <div
                className='layoutModalInfoInnerContainer_cvrehjvfqw'
                style={{
                  borderRadius: 8,
                  padding: 5,
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between'
                }}
              >
                <Text
                  style={{
                    marginRight: 10
                  }}
                >
                  {'Data: '}
                  <Text strong>
                    {formatDateLocal(date!)}
                  </Text>
                </Text>
                <Text
                  style={{
                    marginRight: 10
                  }}
                >
                  {'Total de congelamentos: '}
                  <Text strong>{poeValorComPontosEmMil(data?.qtdeTotalCongelamentos)}</Text>
                </Text>
                <Text
                  style={{
                    marginRight: 10
                  }}
                >
                  {'Custo total: '}
                  <Text strong>R$ {convertMoedaBRDoJSComAte3CasasDecimais(data?.custoTotal)}</Text>
                </Text>
              </div>
            </div>

            <Tabs
              type="card"
              defaultActiveKey="congelamentos"
              className='tab-municipios'
            >
              <Tabs.TabPane
                tab={(
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12
                    }}
                  >
                    <span>Congelamento único por CNPJ</span>

                    <div
                      style={{
                        padding: "0 6px",
                        borderRadius: 4,
                        background: "#30912D"
                      }}
                    >
                      <span style={{ color: "#FFFFFF" }} >{data?.qtdeCongelamentosUnicos}</span>
                    </div>
                  </div>
                )}
                key="congelamentos"
              >
                <AbaCongelamentosUnicos congelamentos={data?.congelamentosUnicos || []} />
              </Tabs.TabPane>

              <Tabs.TabPane
                tab={(
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12
                    }}
                  >
                    <span>Congelamentos em lote</span>

                    <div
                      style={{
                        padding: "0 6px",
                        borderRadius: 4,
                        background: "#30912D"
                      }}
                    >
                      <span style={{ color: "#FFFFFF" }} >{data?.qtdeCongelamentosEmLote}</span>
                    </div>
                  </div>
                )}
                key="importacoes"
              >
                <AbaCongelamentosEmLote congelamentos={data?.solicitacoesCongelamentosEmLote || []} />
              </Tabs.TabPane>
            </Tabs>
          </>
        )
      }
    </Modal>
  )
}
